<template>
    <div>
        <p class="font-weight-bold">Configuração de Abas do Boletim</p>

        <app-erros-box
            :erros="erros"
            v-if="erros.length > 0"
        />

        <app-tabela
            :itens="abasConfiguraveisFiltradas"
            :campos="camposTabelaConfiguracoes"
            :bordered="false"
            :small="false"
            :mostrarFiltro="false"
            :itensPorPagina="0"
        >
            <template slot="ativo" slot-scope="data">
                <toggle-switch
                    v-model="data.ativo"
                    :disabled="data.contratoPossuiBoletinsMedicao || !data.abaBoletimMedicao.permiteDesativar || data.abaBoletimMedicao.codigo === 'MEMORIA_CALCULO'"
                    :title="data.abaBoletimMedicao.codigo === 'MEMORIA_CALCULO' ? 'Memória de Cálculo é obrigatória' : 'Ativar/desativar aba do boletim de medição'"
                    @input="mudarStatusAbaBoletim(data, $event)"
                />
            </template>
        </app-tabela>

        <p class="mt-4 font-weight-bold">Histórico de alterações</p>

        <app-tabela
            :itens="historicoConfiguracoesAbaBoletinsMedicao"
            :campos="camposTabelaHistorico"
            :bordered="false"
            :small="false"
            :mostrarFiltro="false"
        >
            <template slot="data" slot-scope="data">
                {{ data.data | toDateTime }}
            </template>
        </app-tabela>

        <div v-if="permiteAlteracao" class="mt-3">
            <button
                class="btn btn-primary"
                @click="salvar"
            >
                Salvar
            </button>
        </div>
    </div>
</template>

<script>
import ContratosServicos from '../ContratosServicos';
import ToggleSwitch from '../../../../shared/components/ToggleSwitch.vue';

export default {
    components: {
        ToggleSwitch
    },

    data() {
        return {
            erros: [],
            configuracoesAbaBoletinsMedicao: [],
            historicoConfiguracoesAbaBoletinsMedicao: [],
            camposTabelaConfiguracoes: [
                {
                    key: 'abaBoletimMedicao.nome',
                    label: 'Nome da Aba',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'ativo',
                    label: 'Ativo?',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-right',
                    thClass: 'text-right',
                    thStyle: { width: '10rem' }
                },
            ],
            camposTabelaHistorico: [
                {
                    key: 'responsavel',
                    label: 'Usuário',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'data',
                    label: 'Data',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acao',
                    label: 'Ação efetuada',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
            ],
        }
    },

    computed: {
        abasConfiguraveisFiltradas() {
            return this.configuracoesAbaBoletinsMedicao.filter(c => c.abaBoletimMedicao?.permiteDesativar === true);
        },

        permiteAlteracao() {
            return !this.configuracoesAbaBoletinsMedicao.some(x => x.contratoPossuiBoletinsMedicao);
        }
    },

    methods: {
        obterConfiguracaoAbasBoletinsMedicao() {
			this.$store.dispatch('addRequest')

            ContratosServicos.obterConfiguracaoAbasBoletinsMedicao(this.$route.params.codContrato)
                .then(response => {
                    this.$set(this, 'configuracoesAbaBoletinsMedicao', response.data);
                    // Junta todos os históricos de todas as configurações em uma única lista e ordena por data decrescente
                    const historico = Array.isArray(response.data)
                        ? response.data.reduce((acc, config) => {
                            if (Array.isArray(config.historico)) {
                                return acc.concat(config.historico);
                            }
                            return acc;
                        }, [])
                        .sort((a, b) => new Date(b.data) - new Date(a.data))
                        : [];
                    this.$set(this, 'historicoConfiguracoesAbaBoletinsMedicao', historico);
                })
                .catch(error => {
                    console.error('Erro ao obter configuração de abas do boletim de medição:', error)
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        salvar() {

            this.$store.dispatch('addRequest')

            ContratosServicos.atualizarConfiguracaoAbasBoletinsMedicao(this.$route.params.codContrato, this.configuracoesAbaBoletinsMedicao)
                .then(response => {
                    if (response.data && response.data.success) {
                        this.erros = [];

                        this.$toast.success(
                            'Configurações salvas com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )

                        this.obterConfiguracaoAbasBoletinsMedicao();
                    } else {
                        this.erros = response.errors

                        this.$toast.error(
                            'Erro ao atualizar as Configurações de Abas do Boletim de Medição.',
                            'Erro',
                            this.$toastConfig.error
                        )
                    }
                })
                .catch(error => {
                    this.erros = error;

                    this.$toast.error(
                        'Erro ao atualizar as Configurações de Abas do Boletim de Medição.',
                        'Erro',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        mudarStatusAbaBoletim(aba, event) {
            const indiceElemento = this.configuracoesAbaBoletinsMedicao.findIndex(item => item.configuracaoAbaBoletimMedicaoId === aba.configuracaoAbaBoletimMedicaoId)
            if (indiceElemento !== -1) {
                this.$set(this.configuracoesAbaBoletinsMedicao, indiceElemento, {
                    ...aba,
                    ativo: event,
                    obrigatorio: event
                })
            }
        },
    },

    created() {
        this.obterConfiguracaoAbasBoletinsMedicao();
    },
}
</script>
